import styled, { css } from 'styled-components';
import IconComponent from '../Icon';

export const Wrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.sz.md}) {
    width: auto;
  }
`;

export const Icon = styled(IconComponent)(
  ({ theme }) => css`
    position: absolute;
    border-radius: 50%;

    bottom: ${theme.sz.s0};
    right: calc(-1 * ${theme.sz.s6} / 2);

    svg {
      width: ${theme.sz.s6};
      height: ${theme.sz.s6};
    }

    @media (max-width: ${theme.sz.md}) {
      right: calc(-1 * ${theme.sz.s5} / 2);

      svg {
        width: ${theme.sz.s5};
        height: ${theme.sz.s5};
      }
    }
  `,
);

export const IconContainer = styled.div<{ $positionRelative?: boolean }>(
  ({ $positionRelative }) => css`
    position: ${$positionRelative && 'relative'};
  `,
);

export const MainIcon = styled.div(
  ({ theme }) => css`
    height: ${theme.sz.s10};

    svg {
      width: ${theme.sz.s10};
      height: ${theme.sz.s10};
    }

    @media (max-width: ${theme.sz.md}) {
      height: ${theme.sz.s8};

      svg {
        width: ${theme.sz.s8};
        height: ${theme.sz.s8};
      }
    }
  `,
);
